import { Component, TemplateRef, input } from '@angular/core';

@Component({
  host: {
    class: 'd-flex border-bottom p-2',
  },
  selector: 'portal-elements-selector-item',
  templateUrl: './elements-selector-item.component.html',
  styles: [],
  standalone: false,
})
export class ElementsSelectorItemComponent<T> {
  buttonPlacement = input<'left' | 'right'>('left');
  callback = input<(element: T) => void>(undefined);
  element = input<T>(undefined);
  elementTemplate = input<TemplateRef<any>>(undefined);
  highlight = input<boolean>(false);
  icon = input<string>(undefined);
  readonly = input<boolean>(false);
}
